import {
  OnInit,
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  StaffEventSkeleton,
  StaffEventAudit,
  StaffEventBusinessPersonAudit,
  StaffEventBusinessPersonSkeleton,
  ScheduledEventAudit
} from '../../+models/staff-event-audit.model';
import { StaffEventBusinessPersonAuditListComponent } from '../staff-event-business-person-audit-list/staff-event-business-person-audit-list.component';

@Component({
  selector: 'sd-portal-staff-event-audit-list',
  templateUrl: './staff-event-audit-list.component.html',
  styleUrls: ['./staff-event-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaffEventAuditListComponent implements OnInit {
  @Input() staffEvent: StaffEventSkeleton;

  @Input() loading: boolean;
  @Input() staffEventAudits: StaffEventAudit[];
  @Input() scheduledEventAudits: ScheduledEventAudit[];
  @Output() loadStaffEvent = new EventEmitter<number>();
  @Output() loadScheduledEvent = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();
  @Output() nextScheduledEventPage = new EventEmitter<number>();

  @Input() staffEventBusinessPersonLoading: boolean;
  @Input() staffEventBusinessPersonAudits: StaffEventBusinessPersonAudit[];
  @Output() loadStaffEventBusinessPerson = new EventEmitter<number>();
  @Output() loadNextStaffEventBusinessPersonPage = new EventEmitter<number>();

  @ViewChildren(StaffEventBusinessPersonAuditListComponent)
  staffEventBusinessPersonAuditLists: QueryList<StaffEventBusinessPersonAuditListComponent>;

  get combinedAudits() {
    return this.staffEventAudits.concat(this.scheduledEventAudits);
  }

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadStaffEvent.emit(this.staffEvent.staffEventId);
    this.loadScheduledEvent.emit(this.staffEvent.scheduledEventId);
  }

  onNextPage() {
    this.nextPage.emit(this.staffEvent.staffEventId);
    this.nextScheduledEventPage.emit(this.staffEvent.scheduledEventId);
  }

  staffEventBusinessPersonOpened(staffEventBusinessPerson: StaffEventBusinessPersonSkeleton) {
    setTimeout(() => {
      const match = this.staffEventBusinessPersonAuditLists.find(
        c =>
          c.staffEventBusinessPerson.staffEventBusinessPersonId ===
          staffEventBusinessPerson.staffEventBusinessPersonId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }
}
